import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="access-hubs"
export default class extends Controller {
  static values = {
    action: String
  }

  connect() {
    this.selectedRows = []

    document.addEventListener('datagrids--table:selection-changed', this._handleDataGridSelectionChanged)

    this.element.addEventListener("click", (e) => {
      e.preventDefault()
      this._runAction()
    })
  }

  disconnect() {
    document.removeEventListener('datagrids--table:selection-changed', this._handleDataGridSelectionChanged)
  }

  _handleDataGridSelectionChanged = (event) => {
    this.selectedRows = event.detail.selectedRows
  }

  _runAction() {
    if (!this.hasActionValue) {
      console.error("No action specified!")
      return
    }

    this._collectSelectedIds()

    if (this.selectedRows.length === 0) {
      alert("First you have to select some access hubs.")
      return
    }

    if (!confirm('Are you sure?')) {
      return
    }

    const url = `/access_hubs/${this.actionValue}`
    const params = new URLSearchParams()
    this.selectedRows.forEach(id => params.append('ids[]', id))

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''

    fetch(`${url}?${params.toString()}`, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken
      }
    })
    .then(response => response.json())
    .then(data => {
      alert(this._resultText(data))
      window.location.reload()
    })
    .catch(error => {
      console.error('Error:', error)
      alert('An error occurred while processing the request.')
    })
  }

  _collectSelectedIds() {
    this.selectedRows = []
    document.querySelectorAll('table.datagrid > tbody input[type="checkbox"][name="row_selector"]:checked').forEach((item) => {
      this.selectedRows.push(item.value)
    })
  }

  _resultText(data) {
    let text = this._successText(data.success)
    if (data.errors && data.errors.length > 0) {
      text += this._errorsText(data.errors)
    }
    return text
  }

  _successText(successes) {
    const count = successes ? successes.length : 0
    let text = `${count} `
    text += count === 1 ? "device was updated" : "devices were updated"
    if (count > 0) {
      text += `\nIDs: ${successes.join(', ')}`
    }
    return text
  }

  _errorsText(errors) {
    const count = errors.length
    let text = `\n\n${count} `
    text += count === 1 ? "device was not updated!" : "devices were not updated!"
    if (count > 0) {
      text += `\nIDs: ${errors.join(', ')}`
    }
    return text
  }
}
